module.exports = __webpack_public_path__ + "img/good.de203b19.png";